import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { Event } from '../../../types/Event';
import StatusPill from '../../../uikit/pills/StatusPill';
import AppLink from '../AppLink/AppLink';
import { humanizeEventDateTimes } from '../../../utility/dateUtils';

const isCompletedAndPast = (status: string | null, startDate: string | null) => {
  if (!startDate || !status) return false;
  const today = new Date();
  const eventDate = new Date(startDate);
  return eventDate < today && status === 'Complete';
};
interface IEventsTimelineTableProps {
  timelineData: Event[];
}

const EventsTimelineTable = ({ timelineData }: IEventsTimelineTableProps) => {
  const navigate = useNavigate();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>EVENT NAME</TableCell>
            <TableCell>EVENT Date</TableCell>
            <TableCell>STATUS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {timelineData.map((item: Event) => {
            const completedAndPast = isCompletedAndPast(item.status, item.start_at);
            const rowStyle = completedAndPast ? { backgroundColor: '#ebeced' } : {};

            return (
              <TableRow key={item.uuid} onClick={() => navigate(`/${ROUTE_PATHS.EVENTS}/${item.uuid}`)} sx={{ ...rowStyle, cursor: 'pointer' }}>
                <TableCell>
                  <AppLink to={`/${ROUTE_PATHS.EVENTS}/${item.uuid}`}>{item.display_name}</AppLink>
                </TableCell>
                <TableCell>{humanizeEventDateTimes(item)}</TableCell>
                <TableCell>{item.status && <StatusPill status={item.status} text={item.status} />}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EventsTimelineTable;
